import React, { Component } from "react";
import { Grid } from "@mui/material";
import { connect } from "react-redux";
import {
  editBandPicture,
  saveBandFailed,
  changePictureCrop,
} from "../actions/editbandactions";
import Cropper from "./Cropper";

class BandPicture extends Component {
  constructor(props) {
    super(props);
    this.cropper = React.createRef(null);
    this.changePicture = this.changePicture.bind(this);
    this.renderImage = this.renderImage.bind(this);
  }

  changePicture(input) {
    const { dispatch } = this.props;

    if (input.target.files && input.target.files[0]) {
      const reader = new FileReader();

      const size = input.target.files[0].size;

      if (size < 25_000_000) {
        reader.onload = (e) => {
          dispatch(editBandPicture(e.target.result));
          if (this.cropper.current != null) {
            this.cropper.current.setImageChanged(true);
          }
        };

        reader.readAsDataURL(input.target.files[0]);
      } else {
        dispatch(saveBandFailed("Image too large"));
      }
    }
  }

  renderImage() {
    const { bandPicture, dispatch, pictureCrop } = this.props;

    if (bandPicture !== null) {
      return (
        <Grid item xs={12}>
          <Cropper
            ref={this.cropper}
            picture={bandPicture}
            pictureCrop={pictureCrop}
            changePictureCrop={(pictureCrop) =>
              dispatch(changePictureCrop(pictureCrop))
            }
          />
        </Grid>
      );
    } else {
      return <Grid item xs={12} />;
    }
  }

  render() {
    const { fileUploadName, reviewState } = this.props;

    return (
      <Grid item xs={12}>
        <Grid
          container
          direction="column"
          alignItems="center"
          justifyContent="center"
          spacing={3}
        >
          {reviewState !== 'REJECTED' ? this.renderImage() : <React.Fragment/>}
          <Grid item xs={12}>
            <label className="bbe-button">
              <input
                id="BandPictureUpload"
                className="bbe-button"
                type="file"
                accept="image/*"
                onChange={this.changePicture}
              />
              {fileUploadName}
            </label>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
  bandPicture: state.editband.bandPicture,
  fileUploadName: state.editband.fileUploadName,
  pictureCrop: state.editband.pictureCrop,
  reviewState: state.editband.reviewState
});

export default connect(mapStateToProps)(BandPicture);
